import React from 'react';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './DownloadsPage.css';

const DownloadsPage = ({ darkMode, toggleDarkMode }) => {
  const apps = [
    {
      id: 'simply',
      name: 'Simply',
      description: 'Software de gestión empresarial exclusivo para clientes autorizados',
      icon: '💼',
      platforms: [
        {
          name: 'Windows',
          icon: '🪟',
          status: 'available',
          downloadUrl: 'https://e-asyapps.s3.eu-west-3.amazonaws.com/Simply.exe',
          version: '2.0.0'
        },
        {
          name: 'macOS',
          icon: '🍎',
          status: 'available',
          downloadUrl: 'https://dl.velneo.com/velneo/37/velneo-macos64-vclient-setup-37.2.4.dmg',
          version: '2.0.0'
        },
        {
          name: 'iPhone',
          icon: '📱',
          status: 'available',
          downloadUrl: 'https://itunes.apple.com/us/app/velneo-vclient/id1040113146?l=es&mt=8',
          version: '1.0.0'
        },
        {
          name: 'Android',
          icon: '🤖',
          status: 'available',
          downloadUrl: 'https://e-asyapps.s3.eu-west-3.amazonaws.com/simply_arm.apk',
          version: '1.0.0'
        }
      ]
    },
    {
      id: 'swiftlinkerp',
      name: 'SwiftLinkERP',
      description: 'Sistema ERP completo para empresas de todos los tamaños',
      icon: '🏢',
      platforms: [
        {
          name: 'Windows',
          icon: '🪟',
          status: 'available',
          downloadUrl: 'https://e-asyapps.s3.eu-west-3.amazonaws.com/SwiftLink_ERP.exe',
          version: '2.1.0'
        },
        {
          name: 'macOS',
          icon: '🍎',
          status: 'available',
          downloadUrl: 'https://dl.velneo.com/velneo/37/velneo-macos64-vclient-setup-37.2.4.dmg',
          version: '2.1.0'
        },
        {
          name: 'iPhone',
          icon: '📱',
          status: 'available',
          downloadUrl: 'https://itunes.apple.com/us/app/velneo-vclient/id1040113146?l=es&mt=8',
          version: '1.5.0'
        },
        {
          name: 'Android',
          icon: '🤖',
          status: 'available',
          downloadUrl: 'https://e-asyapps.s3.eu-west-3.amazonaws.com/swiftlink_erp_arm.apk',
          version: '1.5.0'
        }
      ]
    }
  ];

  const handleDownload = (platform, appName) => {
    if (platform.status === 'available' && platform.downloadUrl !== '#') {
      window.open(platform.downloadUrl, '_blank');
    } else {
      console.log(`Descargando ${appName} para ${platform.name}`);
    }
  };

  return (
    <>
      <SEO 
        title="Descargas | E-ASY"
        description="Descarga las aplicaciones Simply y SwiftLinkERP para iPhone, Android, Windows y macOS. Gestión empresarial simplificada."
        keywords="descargas, aplicaciones, simply, swiftlinkerp, iphone, android, windows, macos, gestión empresarial"
        canonical="https://e-asy.es/actualizacion"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`downloads-page ${darkMode ? 'dark' : 'light'}`}>
        {/* Hero Section */}
        <section className="downloads-hero">
          <div className="downloads-hero-content">
            <div className="downloads-hero-text">
              <h1 className="downloads-hero-title">Descargas</h1>
              <p className="downloads-hero-subtitle">
                Accede a nuestras aplicaciones Simply y SwiftLinkERP desde cualquier dispositivo. 
                Descarga la versión compatible con tu plataforma.
              </p>
              <div className="downloads-hero-stats">
                <div className="hero-stat">
                  <div className="hero-stat-number">6</div>
                  <div className="hero-stat-label">Plataformas</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">2</div>
                  <div className="hero-stat-label">Aplicaciones</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">24/7</div>
                  <div className="hero-stat-label">Disponibilidad</div>
                </div>
              </div>
            </div>
            <div className="downloads-hero-video">
              <div className="downloads-hero-visual">
                <img
                  src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                  alt="Descargas de aplicaciones"
                  className="downloads-hero-image"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <main className="downloads-main">
          <div className="downloads-content">
            {/* Apps Section */}
            <section className="downloads-apps-section">
              <div className="apps-header">
                <h2 className="apps-title">Nuestras Aplicaciones</h2>
                <p className="apps-subtitle">
                  Elige la aplicación que mejor se adapte a tus necesidades y descarga la versión para tu plataforma
                </p>
              </div>

              <div className="apps-grid">
                {apps.map((app) => (
                  <div key={app.id} className="app-card">
                    <div className="app-header">
                      <div className="app-icon">{app.icon}</div>
                      <div className="app-info">
                        <h3 className="app-name">{app.name}</h3>
                        <p className="app-description">{app.description}</p>
                      </div>
                    </div>

                    <div className="platforms-grid">
                      {app.platforms.map((platform, index) => (
                        <div key={index} className="platform-card">
                          <div className="platform-header">
                            <div className="platform-icon">{platform.icon}</div>
                            <div className="platform-info">
                              <h4 className="platform-name">{platform.name}</h4>
                              <span className="platform-version">v{platform.version}</span>
                            </div>
                          </div>
                          
                          <div className="platform-status">
                            <span className={`status-badge ${platform.status}`}>
                              {platform.status === 'coming-soon' ? 'Próximamente' : 'Disponible'}
                            </span>
                          </div>

                          <button 
                            className={`download-btn ${platform.status}`}
                            onClick={() => handleDownload(platform, app.name)}
                            disabled={platform.status === 'coming-soon'}
                          >
                            {platform.status === 'coming-soon' ? 'Próximamente' : 'Descargar'}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Info Section */}
            <section className="downloads-info-section">
              <div className="info-header">
                <h2 className="info-title">Información de Descargas</h2>
                <p className="info-subtitle">
                  Conoce los requisitos y características de cada aplicación
                </p>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <div className="info-icon">💼</div>
                  <h3 className="info-card-title">Simply</h3>
                  <p className="info-card-description">
                    Software de gestión empresarial exclusivo para clientes autorizados. 
                    Sistema completo para la gestión integral de negocios.
                  </p>
                  <ul className="info-features">
                    <li>Gestión empresarial completa</li>
                    <li>Contabilidad y finanzas</li>
                    <li>Gestión de recursos humanos</li>
                    <li>Reportes y análisis avanzados</li>
                  </ul>
                </div>

                <div className="info-card">
                  <div className="info-icon">🏢</div>
                  <h3 className="info-card-title">SwiftLinkERP</h3>
                  <p className="info-card-description">
                    Sistema ERP completo para empresas de todos los tamaños. 
                    Gestión integral de todos los procesos empresariales.
                  </p>
                  <ul className="info-features">
                    <li>Gestión de recursos empresariales</li>
                    <li>Contabilidad avanzada</li>
                    <li>Gestión de recursos humanos</li>
                    <li>Análisis y reportes avanzados</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Requirements Section */}
            <section className="requirements-section">
              <div className="requirements-header">
                <h2 className="requirements-title">Requisitos del Sistema</h2>
                <p className="requirements-subtitle">
                  Asegúrate de que tu dispositivo cumple con los requisitos mínimos
                </p>
              </div>

              <div className="requirements-grid">
                <div className="requirement-card">
                  <h3 className="requirement-title">iOS (iPhone/iPad)</h3>
                  <ul className="requirement-list">
                    <li>iOS 13.0 o superior</li>
                    <li>1GB de RAM disponible</li>
                    <li>100MB de espacio libre</li>
                    <li>Conexión a internet</li>
                  </ul>
                </div>

                <div className="requirement-card">
                  <h3 className="requirement-title">Android</h3>
                  <ul className="requirement-list">
                    <li>Android 8.0 o superior</li>
                    <li>2GB de RAM disponible</li>
                    <li>150MB de espacio libre</li>
                    <li>Conexión a internet</li>
                  </ul>
                </div>

                <div className="requirement-card">
                  <h3 className="requirement-title">Windows</h3>
                  <ul className="requirement-list">
                    <li>Windows 10 o superior</li>
                    <li>4GB de RAM</li>
                    <li>500MB de espacio libre</li>
                    <li>Conexión a internet</li>
                  </ul>
                </div>

                <div className="requirement-card">
                  <h3 className="requirement-title">macOS</h3>
                  <ul className="requirement-list">
                    <li>macOS 10.15 o superior</li>
                    <li>4GB de RAM</li>
                    <li>500MB de espacio libre</li>
                    <li>Conexión a internet</li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default DownloadsPage;